/**
 * Anonymous Mode Service
 * Permite embaçar nomes de clientes para capturas de tela
 */

class AnonymousModeService {
  constructor() {
    this.isEnabled = false;
    this.init();
  }

  init() {
    // Verificar se estava habilitado
    const saved = localStorage.getItem('anonymousMode');
    if (saved === 'true') {
      this.enable();
    }

    // Atalho de teclado: Ctrl+Alt+A para toggle (evita conflito com Chrome)
    document.addEventListener('keydown', (e) => {
      if (e.ctrlKey && e.altKey && e.key === 'a') {
        e.preventDefault();
        this.toggle();
      }
    });
  }

  enable() {
    this.isEnabled = true;
    document.documentElement.setAttribute('data-anonymous', 'true');
    localStorage.setItem('anonymousMode', 'true');
  }

  disable() {
    this.isEnabled = false;
    document.documentElement.removeAttribute('data-anonymous');
    localStorage.setItem('anonymousMode', 'false');
  }

  toggle() {
    if (this.isEnabled) {
      this.disable();
    } else {
      this.enable();
    }
    return this.isEnabled;
  }

  getStatus() {
    return this.isEnabled;
  }
}

export const anonymousModeService = new AnonymousModeService();

// Expor globalmente para uso via console
window.anonymousMode = {
  enable: () => anonymousModeService.enable(),
  disable: () => anonymousModeService.disable(),
  toggle: () => anonymousModeService.toggle(),
  status: () => anonymousModeService.getStatus()
};
